import React, { useState } from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { useIntl } from 'react-intl';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { capitalize } from '../../../../utility/util/util.service';
import classnames from 'classnames';

const FormField = ({
  type,
  propertyName,
  object,
  messageId,
  label,
  hidden,
  groupClassName,
  value,
  defaultValue,
  preChildren,
  postChildren,
  hideFloatingLabel,
  ...props
}) => {
  const intl = useIntl();
  const _messageId = messageId || 'formField' + capitalize(propertyName);
  const _label = label ?? intl?.formatMessage({ id: _messageId }) ?? '';

  // https://github.com/Availity/availity-reactstrap-validation/blob/master/src/AvInput.js
  return (
    <AvGroup className={classnames('form-label-group', groupClassName)}>
      {preChildren}
      <AvInput
        id={propertyName}
        type={type || 'text'}
        name={propertyName}
        placeholder={_label}
        value={value ?? object?.[propertyName] ?? defaultValue ?? ''}
        hidden={hidden}
        {...props}
      />
      {!hidden && _label && !hideFloatingLabel && (
        <Label className="primary" for={propertyName}>
          {_label}
        </Label>
      )}
      {postChildren}
    </AvGroup>
  );
};

FormField.propTypes = {
  type: PropTypes.string,
  propertyName: PropTypes.string,
  object: PropTypes.object,
  onChange: PropTypes.func,
};

export default FormField;
